"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgInstagram(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M17.005 0a7.003 7.003 0 016.99 6.755l.005.24v10.01a7.003 7.003 0 01-6.755 6.99l-.24.005H6.995a7.003 7.003 0 01-6.99-6.755L0 17.005V6.995A7.003 7.003 0 016.755.005L6.995 0h10.01zm0 1.672H6.995a5.33 5.33 0 00-5.318 5.104l-.005.22v10.009a5.33 5.33 0 005.104 5.318l.22.005h10.009a5.33 5.33 0 005.318-5.104l.005-.22V6.996a5.33 5.33 0 00-5.323-5.323zM12 6.16c3.221 0 5.84 2.62 5.84 5.841 0 3.146-2.499 5.718-5.616 5.836l-.224.005-.224-.005A5.847 5.847 0 016.16 12c0-3.221 2.62-5.84 5.841-5.84zm0 1.673l-.208.005A4.174 4.174 0 007.832 12 4.174 4.174 0 0012 16.168 4.174 4.174 0 0016.168 12a4.174 4.174 0 00-3.96-4.163L12 7.832zM17.903 4.3c.707 0 1.283.575 1.283 1.283s-.576 1.283-1.283 1.283a1.284 1.284 0 01-1.283-1.283c0-.708.575-1.283 1.283-1.283z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgInstagram;
exports.default = _default;